import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  Link,
  useTheme,
  IconButton,
  Divider,
  Paper,
  alpha,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/PhoneRounded';
import EmailIcon from '@mui/icons-material/EmailRounded';
// import LocationOnIcon from '@mui/icons-material/LocationOnRounded'; // Uncomment if needed
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Header from '../components/Header';
import Footer from '../components/Footer';
import EnquirySection from '../components/EnquirySection';

interface ContactUsPageProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const ContactUsPage = ({ mode, setMode }: ContactUsPageProps) => {
  const theme = useTheme();

  // Contact Information
  const contactInfo = {
    email: 'hello@workhorse.com.sg',
    phone: '88413368',
    whatsapp: '88413368',
    address: 'A-6-13, The Tube, Jalan PJU 1/39, Dataran Prima, 47301 Petaling Jaya, Selangor',
    facebook: 'https://www.facebook.com/profile.php?viewas=100000686899395&id=61584101914147',
    instagram: 'https://www.instagram.com/sg.workhorse/',
  };

  // --- Handle Gmail Logic ---
  const handleGmailOpen = () => {
    const subject = encodeURIComponent('General Enquiry via WorkHorse Website');
    const body = encodeURIComponent('Hi, I would like to get in touch regarding...');
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${contactInfo.email}&su=${subject}&body=${body}`;
    window.open(gmailUrl, '_blank');
  };

  // --- Helper for Clean Contact Rows ---
  const ContactRow = ({
    icon,
    label,
    value,
    href,
    isExternal = false,
    onClick
  }: {
    icon: React.ReactNode,
    label: string,
    value: string,
    href?: string,
    isExternal?: boolean,
    onClick?: () => void
  }) => (
    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
      <Box sx={{
        color: 'primary.main',
        bgcolor: theme.palette.mode === 'light' ? 'primary.50' : 'rgba(255,255,255,0.05)',
        p: 1.5,
        borderRadius: '12px',
        height: 'fit-content'
      }}>
        {icon}
      </Box>
      <Box>
        <Typography variant="subtitle2" color="text.secondary" fontWeight={600} sx={{ textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: 1 }}>
          {label}
        </Typography>
        {href || onClick ? (
          <Link
            href={href}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
            onClick={(e) => {
              if (onClick) {
                e.preventDefault();
                onClick();
              }
            }}
            color="text.primary"
            underline="hover"
            sx={{ fontSize: '1.1rem', fontWeight: 500, display: 'block', mt: 0.5, cursor: 'pointer' }}
          >
            {value}
          </Link>
        ) : (
          <Typography color="text.primary" sx={{ fontSize: '1rem', fontWeight: 500, mt: 0.5, lineHeight: 1.6 }}>
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  );

  return (
    <>
      <Header />

      {/* --- CONTENT SECTION --- */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6} alignItems="flex-start"> {/* Use spacing={6} for better separation and alignItems="flex-start" */}

          {/* RIGHT COLUMN: Enquiry Section */}
          <Grid size={{ xs: 12, md: 12 }}> {/* Changed 'size' to 'item' and standard props, check your Grid version */}
             {/* If using Grid v2: <Grid xs={12} md={8}> */}
             {/* The EnquirySection component handles its own internal layout, so placing it here aligns it next to the contact info */}
            <EnquirySection />
          </Grid>

        </Grid>
      </Container>

      <Footer />
    </>
  );
};

export default ContactUsPage;